/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RequestForm } from './requestForm';
import { SenderIdRequestStatus } from './senderIdRequestStatus';

export interface AggregatorApprovalRequestDto { 
    aggregatorStatus?: SenderIdRequestStatus;
    aggregatorEmail?: string;
    aggregatorAccountFullName?: string;
    requestId?: string;
    aggregatorId?: string;
    requestForm?: RequestForm;
}